// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"_0d624b9a27--fullscreen--mfCte","no-print":"_0d624b9a27--no-print--WH57H"};